<template>
    <nav id="primaryNavigation">
        <ol>
            <li v-if="option.allowed" v-show="option.visible" :ref="option.path" v-for="option in menuOptions">
                <a :href="option.url" :class="option.classes" @click="optionSelected($event, option)">
                    <i :class="option.class ?? 'material-icons'">{{ option.icon }}</i><span v-if="option.label && !option.hideLabel">{{ option.label }}</span>
<!--                    <div v-if="option.badge" class="nav-badge red">{{ option.badge }}</div>-->
                    <waiting-badge :count="option.badge" :position="{ top: '13px', left: '32px'}"></waiting-badge>
                    <span v-if="option.beta" class="badge badge-success" style="margin-top: 5px; font-size: 11px; opacity: 1;">BETA</span>
                    <ui-tooltip v-if="option.hideLabel && option.label">{{ option.label }}</ui-tooltip>
                </a>
            </li>
            <li v-if="hasHiddenItems" style="width: 60px">
                <a href="javascript:void(0)" style="">
                    <i class="material-icons">more_vertical</i>
                    <ui-popover ref="dropdown">
                        <ui-menu
                            contain-focus
                            has-icons
                            has-secondary-text

                            :options="hiddenItems"

                            @select="menuItemSelected"

                            @close="$refs.dropdown.close()"
                        ></ui-menu>
                    </ui-popover>
                </a>
            </li>
        </ol>
    </nav>
</template>

<style lang="scss">
    @import '~@/_variables.scss';

    #primaryNavigation {
        position: fixed;
        left: 0; 
        top: $topBarHeight; 
        width: 100%;
        background: $primaryNavigationBackground;
        font-size: .9rem;
        padding-left: 10px;
        padding-right: 10px;
        color: $darkGrey;
        transition: 1s ease-in-out width,box-shadow;
        z-index: 48;
        overflow: hidden;

        a { 
            color: $darkGrey; 
            display: block; 
            padding: 12px 0 6px; 
            cursor: pointer;
            &.active, &:hover { background: #fff; }
        }

        ol { 
            width: 100%;
            margin: 0;
            padding: 0;
            list-style: none;

            li { 
                display: inline-block;

                a {
                    position:relative; 
                    padding: .75rem 1rem .4rem;
                    //padding: .8rem 1.2rem .65rem;
                    span {
                        opacity: 0.7;
                        margin-left: .6rem;
                        vertical-align: top; 
                        font-weight: bold;
                        font-size: .9rem;
                    }

                    &.active, &:hover { 
                        text-decoration: none !important; 
                    }
                }
            }
        }

        .nav-badge {
            font-size: 9px; 
            display: inline; 
            padding: 0px 4px; 
            border-radius: 3px; 
            color: #fff; 
            position: absolute; 
            left: 32px; top: 13px;
            opacity: 1 !important;

            &.green { background: $brand-success;  }
            &.red { background: #bc0101; }
        }
    }
</style>

<script>
    import { mapGetters } from 'vuex'
    import Bus from "../events";
    import WaitingBadge from "../../ts/Elements/WaitingBadge.vue";

    const menuOptions = [
        {
            permissionKey: true,
            path: 'dashboard',
            icon: 'dashboard',
            label: 'Dashboard',
            hideLabel: true,
        },{
            permissionKey: 'access.inbox',
            path: 'inbox/waiting',
            icon: 'inbox',
            isActive() {
                if (this.$route) {
                    return this.$route.path.indexOf('/inbox/') > -1
                }
            },
            label: 'Inbox',
            hideLabel: true,
        },{
            permissionKey: 'list.activity',
            path: 'activities',
            icon: 'today',
            label: 'Diary',
            hideLabel: true,
        },{
            permissionKey: 'manage.inventory',
            path: false,
            icon: 'view_in_ar',
            label: 'Parts & Inventory',
            hideLabel: true,
            class: 'material-icons-outlined',
            onclick() {
                Bus.emit('showInventoryModal')
            }
        },{
            permissionKey: 'view.metrics',
            path: 'metrics',
            icon: 'timeline',
            label: 'Metrics',
            hideLabel: true,
        },{
            permissionKey: true,
            path: 'vehicles',
            icon: 'directions_car',
            label: 'Vehicles',
        },{
            permissionKey: 'list.lead',
            path: 'leads',
            icon: 'my_location',
            label: 'Leads',
        },{
            permissionKey: true,
            path: 'reservations',
            icon: 'lock',
            label: 'Reservations',
        },{
            permissionKey: 'list.deal',
            path: 'deals',
            icon: 'monetization_on',
            label: 'Deals',
        },{
            permissionKey: 'show.valuation',
            path: 'valuations',
            icon: 'trending_down',
            label: 'Valuations',
        },{
            permissionKey: 'see.jobs',
            path: 'jobs/overview',
            icon: 'build',
            label: 'Jobs',
            isActive() {
                if (this.$route) {
                    return this.$route.path.indexOf('/jobs/') > -1
                }
            },
        },{
            permissionKey: 'access.bookings',
            path: 'bookings',
            icon: 'date_range',
            label: 'Bookings',
        },{
            permissionKey: 'list.reservation',
            path: 'courtesy-cars',
            icon: 'stars',
            label: 'Courtesy Cars',
        },{
            permissionKey: 'list.contact',
            path: 'contacts',
            icon: 'contacts',
            label: 'Contacts',
        },{
            permissionKey: 'manage.ads',
            path: 'ads',
            icon: 'ads_click',
            label: 'Ad Manager',
        },{
            permissionKey: 'access.money',
            path: 'money',
            icon: 'account_balance',
            label: 'Accounting',
        },{
            permissionKey: 'manage_finance.accounts',
            path: 'finance',
            icon: 'request_quote',
            label: 'Finance',
        },{
            permissionKey: 'access.reports',
            path: 'reports',
            icon: 'bar_chart',
            label: 'Reports',
        },{
            permissionKey: 'manage.ads',
            path: 'vehicles/grid',
            icon: 'directions_car',
            label: 'Vehicles - Grid View',
        },/*{
            permissionKey: 'access.parts',
            path: 'parts',
            icon: 'category',
            label: 'Stockroom',
        },*/
    ];

    export default {
        components: {WaitingBadge},
        data() {
            return {
                viewportWidth: 0,
                menuOptions: []
            }
        },
        mounted() {
            this.viewportWidth = window.innerWidth
            
            this.populateMenuOptions()

            this.$nextTick(() => {
                this.setItemWidths()
            })

            window.addEventListener('resize', this.updateVisibleItems)

            setInterval(() => {
                this.updateBadges()
            }, 30 * 1000)

            this.updateBadges()

            this.$store.watch((state) => {
                return state.user.badges
            }, (v) => {
                this.updateMenuOptionBadge('leads', v.badges.leads.total)
                this.updateMenuOptionBadge('activities', v.badges.activities)
                this.updateMenuOptionBadge('jobs/overview', v.badges.jobs)
                this.updateMenuOptionBadge('inbox/waiting', v.badges.inbox.waiting)
            }, { deep: true })
        },
        computed: {
            ...mapGetters({
                can: 'user/can'
            }),
            hasHiddenItems() {
                return this.hiddenItems.length > 0
            },
            hiddenItems() {
                return this.menuOptions.filter(i => !i.visible)                              
            },
        },
        methods: {
            optionSelected(event, option) {
                  if (option.onclick) {
                      event.preventDefault()
                      option.onclick(option)
                  }
            },
            menuItemSelected(item) {
                this.$root.navigateTo(item.path)
            },
            setItemWidths() {
                let x = null

                _.each(this.menuOptions, item => {
                    if (!this.$refs[item.path])
                        return;


                    if (x === null) {
                        x = this.$refs[item.path][0].getBoundingClientRect().right
                    } else {
                        x += this.$refs[item.path][0].getBoundingClientRect().width
                    }

                    item.x = x
                })

                this.updateVisibleItems()
            },
            updateVisibleItems() {
                window.requestAnimationFrame(() => {
                    this.viewportWidth = window.innerWidth
                    
                    _.each(this.menuOptions, item => {
                        if (item.x >= (this.viewportWidth - 150)) {
                            item.visible = false
                        } else {
                            item.visible = true
                        }
                    })
                })
            },
            classForOption(option) {
                return option.isActive && option.isActive.call(this) ||
                    this.$root.routeIs(option.path + '.?') ? 'active' : ''
            },
            updateMenuOptionBadge(path, badge) {
                 let index = this.menuOptions.findIndex(item => {
                    return item.path === path
                })

                if (index > -1) {
                    this.menuOptions[index].badge = badge
                }
            },
            updateBadges() {
                if (window.marque.ui.authenticated) {
                    this.$store.dispatch('user/badges/update')
                }
            },
            populateMenuOptions() {
                this.menuOptions = menuOptions.map(option => {
                    if (option.permissionKey !== true) {
                        option.allowed = this.can(option.permissionKey)
                    } else {
                        option.allowed = true
                    }

                    if (!option.badge) {
                        option.badge = false
                    }

                    option.url = option.path ? this.$root.buildUrl(option.path) : '#'
                    option.classes = this.classForOption(option)
                    option.visible = true
                    option.x = 0
                    return option
                })
            }
        }
    }
</script>